// extracted by mini-css-extract-plugin
export var rateTableCarrierDropdown = "_1z-1";
export var rateTableServiceLevelDropdown = "_1z-3";
export var rateTableTypeDropdown = "_1z-0";
export var rateTableValueModeDropdown = "_1z-2";